import { Button } from '@loomhq/lens';
import React from 'react';

import { DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED } from 'constants/events';
import { ADD_COLLABORATOR_CARD_KEY } from 'constants/workspaceOnboarding';
import * as analytics from 'utilities/analytics';
import * as intercom from 'utilities/intercom';

import DashboardOnboardingCard from '../../';

import { SharedSvg } from 'components/videos-dashboard-ta/empty-library-ta/icons';

const PRODUCT_TOUR_ID = 115050;
const PRODUCT_TOUR_LINK = `https://www.loom.com/shared-videos?product_tour_id=${PRODUCT_TOUR_ID}`;

const AddCollaboratorCard = ({ cardConfig }) => {
  const tourIsOnSamePage = PRODUCT_TOUR_LINK.includes(window.location.pathname);
  const buttonAction = () => {
    analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
      type: 'primary',
      card: ADD_COLLABORATOR_CARD_KEY,
    });

    if (!tourIsOnSamePage) {
      window.location.href = PRODUCT_TOUR_LINK;
    } else {
      intercom.startTour(PRODUCT_TOUR_ID);
    }
  };

  const primaryAction = <Button onClick={buttonAction}>Show me how</Button>;

  return (
    <DashboardOnboardingCard
      cardKey={ADD_COLLABORATOR_CARD_KEY}
      cardConfig={cardConfig}
      heading="Invite teammates to edit videos with you"
      description="Invite other members to edit a video in your personal library."
      centerpiece={<SharedSvg />}
      primaryAction={primaryAction}
    />
  );
};

export default AddCollaboratorCard;
